import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Linkedin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_imer-luxury/artifacts/2ygeu2r0_WhatsApp%20Image%202026-04-12%20at%2017.07.32.jpeg';

const Logo = () => (
  <div
    style={{
      background: 'rgba(255,255,255,0.94)',
      padding: '5px 10px',
      borderRadius: '3px',
      border: '1px solid rgba(201,168,76,0.25)',
      display: 'inline-block',
    }}
  >
    <img
      src={LOGO_URL}
      alt="İMER Events & Weddings"
      style={{ height: '42px', width: 'auto', objectFit: 'contain', display: 'block' }}
    />
  </div>
);

const footerNav = [
  {
    title: 'Hizmetler',
    links: [
      { label: 'Kurumsal Etkinlikler', to: '/services/corporate' },
      { label: 'Düğün', to: '/services/wedding' },
      { label: 'Açılış & Lansman', to: '/services/launch' },
      { label: 'Özel Davetler', to: '/services/private' },
    ],
  },
  {
    title: 'Keşfet',
    links: [
      { label: 'Hakkımızda', to: '/about' },
      { label: 'Portföy', to: '/portfolio' },
      { label: 'İletişim', to: '/contact' },
      { label: 'Teklif Al', to: '/quote' },
    ],
  },
];

export default function Footer() {
  return (
    <footer style={{ background: '#07070A', borderTop: '1px solid rgba(201,168,76,0.10)' }}>
      <div className="container-luxury py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <Logo />
            <p className="font-body text-sm text-[rgba(245,240,232,0.55)] mt-6 max-w-xs leading-relaxed">
              Ankara merkezli, Türkiye genelinde hizmet veren premium etkinlik tasarım ve prodüksiyon markası. Kurumsal etkinliklerden düğünlere, lansmanlardan özel davetlere.
            </p>
            <div className="flex flex-col gap-3 mt-8">
              <a
                href="tel:+905314037309"
                className="flex items-center gap-3 font-body text-sm text-[rgba(245,240,232,0.65)] hover:text-[#C9A84C] transition-colors"
              >
                <Phone size={14} className="text-[#C9A84C]" />
                +90 531 403 73 09
              </a>
              <a
                href="mailto:info@imerevents.com"
                className="flex items-center gap-3 font-body text-sm text-[rgba(245,240,232,0.65)] hover:text-[#C9A84C] transition-colors"
              >
                <Mail size={14} className="text-[#C9A84C]" />
                info@imerevents.com
              </a>
              <div className="flex items-start gap-3 font-body text-sm text-[rgba(245,240,232,0.65)]">
                <MapPin size={14} className="text-[#C9A84C] flex-shrink-0 mt-0.5" />
                Ankara, Türkiye
              </div>
            </div>
            <div className="flex items-center gap-4 mt-8">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full flex items-center justify-center border transition-all duration-200 hover:border-[#C9A84C] hover:text-[#C9A84C] text-[rgba(245,240,232,0.5)]"
                style={{ borderColor: 'rgba(201,168,76,0.2)' }}
                aria-label="Instagram"
              >
                <Instagram size={15} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full flex items-center justify-center border transition-all duration-200 hover:border-[#C9A84C] hover:text-[#C9A84C] text-[rgba(245,240,232,0.5)]"
                style={{ borderColor: 'rgba(201,168,76,0.2)' }}
                aria-label="LinkedIn"
              >
                <Linkedin size={15} />
              </a>
            </div>
          </div>

          {/* Nav columns */}
          {footerNav.map((group) => (
            <div key={group.title}>
              <h4 className="font-body text-xs tracking-[0.2em] uppercase text-[#C9A84C] mb-6">{group.title}</h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="font-body text-sm text-[rgba(245,240,232,0.60)] hover:text-[#F5F0E8] transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          className="mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ borderTop: '1px solid rgba(245,240,232,0.07)' }}
        >
          <p className="font-body text-xs text-[rgba(245,240,232,0.35)] tracking-wide">
            &copy; {new Date().getFullYear()} İMER Events & Weddings. Tüm hakları saklıdır.
          </p>
          <p className="font-body text-xs text-[rgba(245,240,232,0.35)] tracking-wide">
            Ankara &bull; Türkiye Geneli Hizmet
          </p>
        </div>
      </div>
    </footer>
  );
}
